import { useLang } from "@/context/LanguageContext";
import { Building2, Landmark, Home, LineChart } from "lucide-react";
import BrandMarkWatermark from "@/components/BrandMarkWatermark";

const ICONS = [Building2, Landmark, Home, LineChart];

export default function Services() {
  const { t } = useLang();

  return (
    <section
      id="services"
      className="relative overflow-hidden section-y bg-[color:var(--anthracite)] text-[color:var(--bone)]"
      data-testid="services-section"
    >
      <BrandMarkWatermark size={780} tone="light" opacity={0.10} style={{ top: -80, right: -100, zIndex: 1 }} />
      <div className="container-lux relative z-10">
        <div className="max-w-3xl">
          <div className="overline" style={{ color: "var(--bronze)" }} data-testid="services-overline">
            {t.services.overline}
          </div>
          <h2
            className="mt-6 font-serif-display text-[clamp(2rem,4.5vw,3.75rem)] leading-[1.05] tracking-[-0.01em]"
            data-testid="services-title"
          >
            {t.services.title}
          </h2>
        </div>

        <div className="mt-20 grid grid-cols-1 md:grid-cols-2 gap-px bg-[color:var(--copper)]/25">
          {t.services.items.map((s, i) => {
            const Icon = ICONS[i] || Building2;
            return (
              <div
                key={s.title}
                className="bg-[color:var(--anthracite)] p-8 md:p-12 group transition-colors duration-500 hover:bg-[color:var(--charcoal)]"
                data-testid={`service-card-${i}`}
              >
                <div className="flex items-start justify-between gap-6">
                  <div className="font-serif-display text-[54px] text-[color:var(--copper)]/50 leading-none">
                    0{i + 1}
                  </div>
                  <Icon
                    size={28}
                    strokeWidth={1}
                    className="text-[color:var(--bronze)] transition-transform duration-500 group-hover:rotate-[10deg]"
                  />
                </div>
                <h3 className="mt-8 font-serif-display text-[28px] leading-tight">{s.title}</h3>
                <p className="mt-4 text-[15px] leading-[1.75] text-[color:var(--bone)]/70 max-w-md">
                  {s.body}
                </p>
                <div className="mt-8 h-px w-12 bg-[color:var(--copper)] group-hover:w-24 transition-[width] duration-500" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
